import React, { useEffect, useState } from "react";
import { toast } from "sonner";

import LoadingScreen from "../Unique/Animation/loading_screen";
import { useAdministrationContext } from "./administration_context";
import { post } from "../../lib/api";

import { Card, CardContent } from "../../components/ui/card";
import { Checkbox } from "../../components/ui/checkbox";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";

const PageManager = () => {
  const { user } = useAdministrationContext();
  const [pages, setPages] = useState([]);
  const [userPages, setUserPages] = useState([]);
  const [loading, setLoading] = useState(true);

  // Load all pages & user-specific pages
  useEffect(() => {
    const fetchData = async () => {
      const allPages = await post({ method: "getPages" });
      const userSpecificPages = await post({
        method: "getPagesOfUser",
        user_id: user[0],
      });

      setPages(allPages);
      setUserPages(userSpecificPages);
      setLoading(false);
    };

    fetchData();
  }, [user]);

  // Check if a page is assigned to current user
  const isPageChecked = (page) => {
    return userPages.some((userPage) => JSON.stringify(userPage) === JSON.stringify(page));
  };

  // Add or remove page for the user
  const handleCheckboxChange = async (page) => {
    const loadingToastId = toast.loading("Updating page access...");

    const method = isPageChecked(page) ? "removePage" : "addPage";

    const data = {
      method,
      parent_id: page.parent_id,
      page_id: page.page_id,
      version_id: page.version_id,
      user_id: user[0],
      game_id: page.game_id,
    };

    try {
      const response = await post(data);

      if (response.status === "error") {
        throw new Error(response.message);
      }

      if (method === "addPage") {
        toast.success(`Added access to page ${page.page_id} for user ${user[1]}! (ID: ${user[0]})`);
        setUserPages([...userPages, page]);
      } else {
        toast.success(`Removed access to page ${page.page_id} for user ${user[1]}! (ID: ${user[0]})`);
        setUserPages(userPages.filter((userPage) => JSON.stringify(userPage) !== JSON.stringify(page)));
      }
    } catch (error) {
      toast.error("Failed to update page access!");
    } finally {
      // Always dismiss the loading toast
      toast.dismiss(loadingToastId);
    }
  };

  if (loading) {
    return <LoadingScreen text="Loading..." />;
  }

  return (
    <Card className="shadow-md overflow-hidden">
      <CardContent className="p-0 overflow-hidden">
        <Table className={"dark:bg-[var(--header-color-dark)]"}>
          <TableHeader className="dark:bg-purple-700/60 dark:text-white sticky">
            <TableRow>
              {/* Empty header for checkbox column */}
              <TableHead className="w-12 sticky" />
              <TableHead>Game</TableHead>
              <TableHead>Variant</TableHead>
              <TableHead className="text-center sticky">Game ID</TableHead>
            </TableRow>
          </TableHeader>

          <TableBody>
            {pages.map((page, index) => (
              <TableRow key={index} className="hover:bg-muted transition-all border-b">
                <TableCell className="w-12">
                  <Checkbox
                    className="shadow-none data-[state=checked]:bg-purple-700 dark:data-[state=checked]:bg-purple-700 text-white"
                    checked={isPageChecked(page)}
                    onCheckedChange={() => handleCheckboxChange(page)}
                  />
                </TableCell>
                <TableCell>
                  {page.parent_id} {page.page_id}
                </TableCell>
                <TableCell>{page.version_id}</TableCell>
                <TableCell className="text-center">{page.game_id}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default PageManager;
